// frontend/src/utils/inferTimeframe.ts
import type { DataPoint } from "@/types/api";

interface Bucket {
  maxSeconds: number;
  label: string;
}

const BUCKETS: Bucket[] = [
  { maxSeconds: 3, label: "1s" },
  { maxSeconds: 10, label: "5s" },
  { maxSeconds: 22, label: "15s" },
  { maxSeconds: 45, label: "30s" },
  { maxSeconds: 90, label: "1m" },
  { maxSeconds: 150, label: "2m" },
  { maxSeconds: 240, label: "3m" },
  { maxSeconds: 450, label: "5m" },
  { maxSeconds: 750, label: "10m" },
  { maxSeconds: 1350, label: "15m" },
  { maxSeconds: 2700, label: "30m" },
  { maxSeconds: 5400, label: "1H" },
  { maxSeconds: 9000, label: "2H" },
  { maxSeconds: 12600, label: "3H" },
  { maxSeconds: 18000, label: "4H" },
  { maxSeconds: 25200, label: "6H" },
  { maxSeconds: 36000, label: "8H" },
  { maxSeconds: 50400, label: "12H" },
  { maxSeconds: 70200, label: "16H" },
  { maxSeconds: 84600, label: "23H" },
  { maxSeconds: 129600, label: "D" },
  { maxSeconds: 259200, label: "2D" },
  { maxSeconds: 475200, label: "4D" },
  { maxSeconds: 1598400, label: "W" },
];

export function inferTimeframe(data: DataPoint[]): string | null {
  if (data.length < 2) return null;

  const intervals: number[] = [];
  for (let i = 1; i < data.length; i++) {
    const diffMs = data[i]!.timestamp - data[i - 1]!.timestamp;
    if (diffMs > 0) {
      intervals.push(diffMs / 1000);
    }
  }

  if (intervals.length === 0) return null;

  const sorted = intervals.slice().sort((a, b) => a - b);
  const median = sorted[Math.floor(sorted.length / 2)]!;

  for (const bucket of BUCKETS) {
    if (median <= bucket.maxSeconds) {
      return bucket.label;
    }
  }

  return "M";
}
